/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimBalanceCarryForwardResponse
 */
export interface ClaimBalanceCarryForwardResponse {
    /**
     * 
     * @type {Date}
     * @memberof ClaimBalanceCarryForwardResponse
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof ClaimBalanceCarryForwardResponse
     */
    affectedClaimCount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimBalanceCarryForwardResponse
     */
    skippedClaimIds: Array<string>;
}

/**
 * Check if a given object implements the ClaimBalanceCarryForwardResponse interface.
 */
export function instanceOfClaimBalanceCarryForwardResponse(value: object): value is ClaimBalanceCarryForwardResponse {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('affectedClaimCount' in value) || value['affectedClaimCount'] === undefined) return false;
    if (!('skippedClaimIds' in value) || value['skippedClaimIds'] === undefined) return false;
    return true;
}

export function ClaimBalanceCarryForwardResponseFromJSON(json: any): ClaimBalanceCarryForwardResponse {
    return ClaimBalanceCarryForwardResponseFromJSONTyped(json, false);
}

export function ClaimBalanceCarryForwardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimBalanceCarryForwardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'affectedClaimCount': json['affectedClaimCount'],
        'skippedClaimIds': json['skippedClaimIds'],
    };
}

export function ClaimBalanceCarryForwardResponseToJSON(json: any): ClaimBalanceCarryForwardResponse {
    return ClaimBalanceCarryForwardResponseToJSONTyped(json, false);
}

export function ClaimBalanceCarryForwardResponseToJSONTyped(value?: ClaimBalanceCarryForwardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'affectedClaimCount': value['affectedClaimCount'],
        'skippedClaimIds': value['skippedClaimIds'],
    };
}

